export default "__VITE_ASSET__DH208hlM__"